import type { ReactNode } from 'react'
import { createContext, useCallback, useContext, useState } from 'react'

interface BreadcrumbActionsContextType {
  actions: ReactNode | null
  setActions: (actions: ReactNode | null) => void
}

const BreadcrumbActionsContext = createContext<BreadcrumbActionsContextType | undefined>(undefined)

export const BreadcrumbActionsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [actions, setActionsState] = useState<ReactNode | null>(null)

  const setActions = useCallback((newActions: ReactNode | null) => {
    setActionsState(newActions)
  }, [])

  return (
    <BreadcrumbActionsContext.Provider value={{ actions, setActions }}>{children}</BreadcrumbActionsContext.Provider>
  )
}

export const useBreadcrumbActions = (): ReactNode | null => {
  const context = useContext(BreadcrumbActionsContext)
  return context?.actions || null
}

export const useSetBreadcrumbActions = (): ((actions: ReactNode | null) => void) => {
  const context = useContext(BreadcrumbActionsContext)
  if (!context) {
    // Return a no-op if context is not available
    return () => {}
  }
  return context.setActions
}
